import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <p><strong>Description</strong></p>
  <p>
      Associates are being placed in processes without proper training This is against Amazon policies and network standard and needs to be mitigated immediately. There is a proven elevated safety risk involved for Associates placed, but
      not properly trained in processes. Proper training is key to associate safety, quality and productivity.&nbsp;
  </p>
  <p><strong>Resolution Steps If the AA is On-Site</strong></p>
  <p>
      1) Remove the associate from path and return them to their home process.<br />
      2) Provide the associate with proper training prior to placing them in the path removed.
  </p>
  <p><strong>Resolution Steps If the individual is NOT On-Site</strong></p>
  <p>
      1) Close ATV Alerts for individuals not in the building, and comment what caused the error. <br />
      2) Verify PPA Labor Tracking. <br />
      3) Audit to confirm there are no broken, faded or damaged labor tracking barcodes. Damaged barcodes can cause false ATV Alerts if only a portion of the barcode is read causing leaders outside of AMZL with low badge IDs to be labor
      tracked.
  </p>

</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_ATV.jsx